import axios from "../customize_axios";

export const getRevenueByYear = async (token, year) => {
    try {
        const response = await axios.get(
            `api/order/revenue/${year}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getRevenueByYear", error.response ? error.response.data : error.message)
    }
}

export const getVietnamOrderData = async (token, dateRange) => {
    try {
        const response = await axios.get(
            `api/order/top-city?start=${dateRange.start}&end=${dateRange.end}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getVietnamOrderData", error.response ? error.response.data : error.message)
    }
}

export const getAgeGroupOrderData = async (token, dateRange) => {
    try {
        console.log(dateRange)
        const response = await axios.get(
            `api/targets/statistic?start=${dateRange.start}&end=${dateRange.end}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getAgeGroupOrderData", error.response ? error.response.data : error.message)
    }
}

export const getCategoriesRevenueData = async (token, dateRange) => {
    try {
        console.log(dateRange)
        const response = await axios.get(
            `/api/category/revenue?start=${dateRange.start}&end=${dateRange.end}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getCategoriesRevenueData", error.response ? error.response.data : error.message)
    }
}